<!-- Opt In Form -->

@if (showVerify && verifyVehicleData.opt_in) {
<div class="verify-vehicle opt-in">
  <div class="row">
    <!-- <div *ngIf="!((appFlowState$ | async) === 'guest' || (appFlowState$ | async) === 'edit')" class="row"> -->
    @if (!((appFlowState$ | async) === 'guest' || (appFlowState$ | async) === 'edit')) {
    <div class="col-12 vehicle-info">
      @if (vehicle$ | async; as vehicle) {
      <div class="mb-3 mobile">
        <div class="view image-cropper image-border mr-3 d-flex align-items-center"
          [ngClass]="{'hide-slug': vehicle.image}">
          @if (vehicle.image) {
          <img [src]="vehicle.image"
            alt="{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.trim }}" />
          }
        </div>
        <div class="vehicle_edit_btn d-flex justify-content-center align-items-center" (click)="editVehicle()">
          <mdb-icon fas icon="pencil-alt"></mdb-icon>
        </div>
      </div>
      }
    </div>
    }
    <div class="col-12 vehicle-info">
      <div class="">
        <!-- Desktop View-->
        @if (!((appFlowState$ | async) === 'guest' || (appFlowState$ | async) === 'edit')) {
        <div class="desktop col-xl-12">
          <div class="d-flex justify-content-center align-items-center">
            @if (vehicle$ | async; as vehicle) {
            <div class="vehicle_section mb-3">
              <div class="view image-cropper image-border mr-3 d-flex align-items-center"
                [ngClass]="{'hide-slug': vehicle.image}">
                @if (vehicle.image) {
                <img [src]="vehicle.image"
                  alt="{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.trim }}" />
                }
              </div>
              <div class="vehicle_edit_btn d-flex justify-content-center align-items-center" (click)="editVehicle()">
                <mdb-icon fas icon="pencil-alt"></mdb-icon>
              </div>
            </div>
            }
            @if (vehicle$ | async; as vehicle) {
            <div class="d-flex flex-column justify-content-center">
              <div tabindex="0" class="bold uppercase">{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }} {{
                vehicle.trim }}</div>
              <div class="mb-3" role="region" tabindex="0">{{ 'ASP_LANDING.VIN' | translate }} {{ vehicleVin }}</div>
            </div>
            }
          </div>
        </div>
        }
        <!-- Mobile View-->
        @if (!((appFlowState$ | async) === 'guest' || (appFlowState$ | async) === 'edit')) {
        <div class="pr-4 pl-4 mobile">
          <div class="d-flex justify-content-center">
            @if (vehicle$ | async; as vehicle) {
            <div class="d-flex flex-column justify-content-center">
              <div tabindex="0" class="bold uppercase text-center">{{ vehicle.year }} {{ vehicle.make }} {{
                vehicle.model
                }} {{ vehicle.trim }}</div>
              <div class="mb-3 text-center" role="region" tabindex="0">{{ 'ASP_LANDING.VIN' | translate }} {{ vehicleVin
                }}</div>
            </div>
            }
          </div>
        </div>
        }
        <!-- Opt In Form Alerts -->
        @if (vehicle$ | async; as vehicle) {
        <div class="p-0">
          <div class="mt-2 mb-4">
            @if ((modalComponentState$ | async) === 'error') {
            <div class="alert alert-warning verify-alert w-100" role="alert">
              @if (currentBrand != 'NCESI' && !((currentBrand === 'BMW' || currentBrand === 'MINI') &&
              modelOptInForm.get('registeredState')?.value === 'CA')) {
              <span>
                {{ 'ERRORS.NO_ELIGIBLE_PRODUCTS' | translate }} {{ branding.cs_phone_number }}
              </span>
              }
              @if ((currentBrand === 'BMW' || currentBrand === 'MINI') && modelOptInForm.get('registeredState')?.value
              === 'CA') {
              <span>
                {{'ERRORS.NO_ELIGIBLE_PRODUCTS_CA' | translate: {brand: currentBrand} }}
              </span>
              }
              @if (currentBrand == 'NCESI') {
              <span>
                {{ 'ERRORS.NEED_MORE_INFO' | translate }} {{ branding.cs_phone_number }}
              </span>
              }
            </div>
            }
            @if ((modalComponentState$ | async) === 'invalidState') {
            <div class="alert alert-warning verify-alert w-100" id="invalidStateMobile" role="alert">
              {{ 'ERRORS.NO_PRODUCTS_STATE' | translate }} {{ branding.cs_phone_number }}
            </div>
            }
            @if ((modalComponentState$ | async) === 'productExist') {
            <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.CONTRACT_EXISTS' | translate }}
              {{
              branding.cs_phone_number }}
            </div>
            }
            @if ((modalComponentState$ | async) === 'lamboNeverEligible') {
            <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.NO_ELIGIBLE_PRODUCTS' |
              translate }}
              {{branding.cs_phone_number }}
            </div>
            }
            @if ((modalComponentState$ | async) === 'hasExistingClaims') {
            <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.ACTIVE_CLAIMS_ERROR' | translate
              }}
            </div>
            }
            @if ((modalComponentState$ | async) === 'mileageOrAgeExceeded') {
            <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.MILEAGE_OR_AGE_EXCEEDED' |
              translate }}
            </div>
            }
            @if ((modalComponentState$ | async) === 'ncesiMileageOrAgeExceeded') {
            <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.NCESI_MILEAGE_OR_AGE_EXCEEDED' |
              translate }}
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
    <!-- Opt In Form -->
    <div class="col-12 pr-0 pl-0">
      <div class="w-100 mb-5 plan-title text-center">
        <h3>{{ 'ASP_LANDING.GET_YOUR_PLAN'| translate }}</h3>
      </div>
      <div>
        <form class="text-center p-3" class="stateMileageForm OID-form" [formGroup]="modelOptInForm" role="form">
          @if (((appFlowState$ | async) === 'guest' || (appFlowState$ | async) === 'edit')) {
          <div class="md-form mt-3 ml-1 mr-1">
            <a id="whereFindVinLinkOptIn" role="link" tabindex="0" class="where-vin blue-link uppercase"
              (click)="launchVin()">{{
              'ASP_LANDING.WHERE_FIND_VIN' | translate }}</a>
            <label id="vinlabel" for="vinInput">{{ 'ASP_LANDING.VIN' | translate }}</label>
            <input aria-labelledby="vinlabel" mdbInput mdbValidate type="text" id="vinInput" formControlName="vin"
              class="form-control" minlength="17" maxlength="17" />
          </div>
          }
          @if (modelOptInForm.controls.vin.invalid && (modelOptInForm.controls.vin.dirty ||
          modelOptInForm.controls.vin.touched)) {
          <mdb-error role="alert">
            @if (modelOptInForm.controls.vin.errors.required) {
            <span>*{{ 'ASP_LANDING.VIN_REQUIRED' |
              translate }}</span>
            }
            @if (modelOptInForm.controls.vin.errors.minlength) {
            <span>*{{ 'ASP_LANDING.VALID_VIN' |
              translate }}</span>
            }
          </mdb-error>
          }
          <div class="md-form mt-3 ml-1 mr-1">
            <label class="no-touch-label" id="stateLabel" for="registeredState"
              [ngClass]="{ active: modelOptInForm.controls.registeredState.value != null }"> {{ 'ASP_LANDING.STATE'
              | translate }}</label>
            <select role="listbox" aria-labelledby="stateLabel" id="stateOfVehicleRegistrationSelect"
              class="form-control" formControlName="registeredState" (change)="stateSelectedDirectMarketing()"
              placeholder="Registered in... *">
              @for (state of stateData; track state) {
              <option value="{{ state.value }}">{{ state.label }}</option>
              }
            </select>
          </div>
          @if (modelOptInForm.controls.registeredState.invalid && (modelOptInForm.controls.registeredState.dirty ||
          modelOptInForm.controls.registeredState.touched)) {
          <mdb-error role="alert">*{{
            'ASP_LANDING.STATE_REQUIRED' | translate }}
          </mdb-error>
          }
          <div class="md-form mt-3 ml-1 mr-1">
            <label id="odometerIdlabel" for="odometerId" class="no-touch-label">{{ 'ASP_LANDING.CURRENT_MILEAGE' |
              translate }} @if (odometerTooltip) {
              <app-tooltip message="{{odometerTooltip}}"></app-tooltip>
              }</label>
            <input data-public aria-labelledby="odometerIdlabel" mdbInput mdbValidate type="text"
              id="currentMileageInput" formControlName="odometer" class="form-control"
              (keypress)="onlyNumberKey($event)" (focus)="removeCommasDirectMarketing()"
              (change)="removeCommasDirectMarketing()" (blur)="addCommasDirectMarketing()" max="100000" />
            <div class="invalid-feedback" for="odometerId">{{ 'ASP_LANDING.ENTER_MILEAGE' | translate }}</div>
          </div>
          @if (modelOptInForm.controls.odometer.invalid && (modelOptInForm.controls.odometer.dirty ||
          modelOptInForm.controls.odometer.touched)) {
          <mdb-error role="alert" class="mileage-error">*{{
            'ASP_LANDING.MILEAGE_REQUIRED' | translate }}
          </mdb-error>
          }
          <div class="md-form mt-3 ml-1 mr-1 shorten-form">
            <label class="no-touch-label" id="emailIdLabel" for="emailId"
              [ngClass]="{ active: modelOptInForm.controls.email.value != null }"> {{ 'ASP_LANDING.EMAIL'
              | translate }}</label>
            <input data-public aria-labelledby="emailIdlabel" mdbInput mdbValidate type="text" id="emailId"
              (focus)="opt_in_names.show()" formControlName="email" class="form-control" />
            @if (modelOptInForm.controls.email.invalid && (modelOptInForm.controls.email.dirty ||
            modelOptInForm.controls.email.touched)) {
            <mdb-error role="alert">*{{
              'ASP_LANDING.EMAIL_REQUIRED' | translate }}
            </mdb-error>
            }
          </div>
          <div class="row" mdbCollapse #opt_in_names [isCollapsed]="true">
            <div class="col-6 pl-1 pr-1">
              <div class="md-form shorten-form">
                <label class="no-touch-label" id="firstNameLabel" for="firstName"
                  [ngClass]="{ active: modelOptInForm.controls.firstName.value != null }"> {{ 'ASP_LANDING.FIRST_NAME'
                  | translate }}</label>
                <input data-public aria-labelledby="firstNameLabel" mdbInput mdbValidate type="text" id="firstName"
                  formControlName="firstName" class="form-control" />
                @if (modelOptInForm.controls.firstName.invalid && (modelOptInForm.controls.firstName.dirty ||
                modelOptInForm.controls.firstName.touched)) {
                <mdb-error role="alert">*{{
                  'ASP_LANDING.FIRST_NAME_REQUIRED' | translate }}
                </mdb-error>
                }
              </div>
            </div>
            <div class="col-6 pl-1 pr-1">
              <div class="md-form shorten-form">
                <label class="no-touch-label" id="lastNameLabel" for="lastName"
                  [ngClass]="{ active: modelOptInForm.controls.lastName.value != null }"> {{ 'ASP_LANDING.LAST_NAME'
                  | translate }}</label>
                <input data-public aria-labelledby="lastNameLabel" mdbInput mdbValidate type="text" id="lastName"
                  formControlName="lastName" class="form-control" />
                @if (modelOptInForm.controls.lastName.invalid && (modelOptInForm.controls.lastName.dirty ||
                modelOptInForm.controls.lastName.touched)) {
                <mdb-error role="alert">*{{
                  'ASP_LANDING.LAST_NAME_REQUIRED' | translate }}
                </mdb-error>
                }
              </div>
            </div>
          </div>
          <div class="w-100 pb-3">
            <input [checked]="optInBoolean" [default]="optInBoolean" type="checkbox"
              class="form-check-input text-left pb-5" id="emailToggle" formControlName="contactToggle"
              (click)="handleFormRequirements(opt_in_names)">
            <label class="pl-4 form-check-label" for="emailToggle">{{ 'ASP_LANDING.ENTER_EMAIL' | translate: {
              currentBrand: currentBrand } }}</label>
          </div>
          <div class="row w-100 mt-2">
            <div class="col-12 d-flex justify-content-center">
              <button mdbBtn id="getYourPriceButton"
                class="modal-component-see-pricing-btn btn primary-btn flat waves-light" mdbWavesEffect type="submit"
                [disabled]="inlineLoader$ | async" (click)="optInFormSubmit()">
                <span>
                  @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
                  <span class="">{{buttonText}}</span>
                  }
                </span>
                @if (inlineLoader$ | async) {
                <span>
                  <span class="spinner-border spinner-border-sm"></span>
                  {{ 'ASP_LANDING.LOADING' | translate }}
                </span>
                }
              </button>
            </div>
            <div mdbCollapse #contact_me [isCollapsed]="true" class="w-100">
              <div class="top-border w-100 mt-4 mb-4 pt-4">
                <form [formGroup]="contactMeForm">
                  <div class="md-form mt-3 ml-1 mr-1">
                    <label class="no-touch-label" id="phoneId" for="phone"
                      [ngClass]="{ active: contactMeForm.controls.phone.value != null }"> {{ 'ASP_LANDING.PHONE' |
                      translate }}</label>
                    <input data-public aria-labelledby="phoneId" mdbInput mdbValidate type="text" id="phone"
                      formControlName="phone" (keypress)="onlyNumberKey($event)" max="10" class="form-control"
                      maxlength="10" />
                  </div>
                  @if (contactMeForm.controls.phone.invalid && (contactMeForm.controls.phone.dirty ||
                  contactMeForm.controls.phone.touched)) {
                  <mdb-error role="alert">*{{
                    'ASP_LANDING.PHONE_REQUIRED' | translate }}</mdb-error>
                  }
                  <div class="md-form mt-3 ml-1 mr-1 shorten-form">
                    <label class="no-touch-label" id="nameId" for="name"
                      [ngClass]="{ active: contactMeForm.controls.name.value != null }"> {{ 'ASP_LANDING.NAME'
                      | translate }}</label>
                    <input data-public aria-labelledby="nameId" mdbInput mdbValidate type="text" id="name"
                      formControlName="name" class="form-control" />
                    @if (contactMeForm.controls.name.invalid && (contactMeForm.controls.name.dirty ||
                    contactMeForm.controls.name.touched)) {
                    <mdb-error role="alert">*{{
                      'ASP_LANDING.NAME_REQUIRED' | translate }}</mdb-error>
                    }
                  </div>
                  <div class="w-100 ">
                    <label class="form-check-label">{{ 'ASP_LANDING.PLEASE_PROVIDE' | translate }}</label>
                  </div>
                </form>
              </div>
            </div>
            @if (!showContactForm) {
            <div>
              <label class="form-check-label pt-4">{{ 'ASP_LANDING.THANK_YOU_INTEREST' | translate: { currentBrand:
                currentBrand } }}</label>
            </div>
            }
            @if (showContactForm) {
            <div class="col-12 d-flex justify-content-center">
              @if (togglecollapsed) {
              <button mdbBtn class="modal-component-see-pricing-btn btn contact-me-btn flat waves-light" mdbWavesEffect
                type="button" [disabled]="(inlineLoader$ | async)" (click)="toggleContact(contact_me)">
                <span>
                  @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
                  <span class="">
                    Contact Me
                  </span>
                  }
                </span>
                @if (inlineLoader$ | async) {
                <span>
                  <span class="spinner-border spinner-border-sm"></span>
                  {{ 'ASP_LANDING.LOADING' | translate }}
                </span>
                }
              </button>
              }
              @if (!togglecollapsed) {
              <button mdbBtn class="modal-component-see-pricing-btn btn contact-me-btn flat waves-light" mdbWavesEffect
                type="button" [disabled]="(inlineLoader$ | async)" (click)="submitContact(contact_me)">
                <span>
                  @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
                  <span class="">
                    Submit
                  </span>
                  }
                </span>
                @if (inlineLoader$ | async) {
                <span>
                  <span class="spinner-border spinner-border-sm"></span>
                  {{ 'ASP_LANDING.LOADING' | translate }}
                </span>
                }
              </button>
              }
            </div>
            }
            @if (!togglecollapsed && showContactForm) {
            <div class="text-center w-100"><a (click)="toggleContact(contact_me)">Cancel</a></div>
            }
            <!-- <div class="col-12 change-vehicle text-center">
              {{ 'ASP_LANDING.NOT_VEHICLE' | translate }}
              <a role="link" href="javascript:void(0)" class="blue-link uppercase" (click)="editVehicle()"
              (click)="view = '2'"> {{ 'ASP_LANDING.CHANGE_VEHICLE' | translate }}</a>
            </div> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}

<!-- Verify Vehicle Form -->

@if (showVerify && !verifyVehicleData.opt_in) {
<div class="verify-vehicle">
  @if (!((appFlowState$ | async) === 'guest' || (appFlowState$ | async) === 'edit')) {
  <div>
    @if (vehicle$ | async; as vehicle) {
    <div class="vehicle_mobile_section mb-3 mobile">
      <div class="view image-cropper image-border mr-3 d-flex align-items-center"
        [ngClass]="{'hide-slug': vehicle.image}">
        @if (vehicle.image) {
        <img [src]="vehicle.image" alt="{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.trim }}" />
        }
      </div>
      <div class="vehicle_edit_btn d-flex justify-content-center align-items-center" (click)="editVehicle()">
        <mdb-icon fas icon="pencil-alt"></mdb-icon>
      </div>
    </div>
    }
  </div>
  }
  @if ((appFlowState$ | async) === 'account' || (appFlowState$ | async) === 'editAccount') {
  <div>
    @if (currentBrand == 'NCESI') {
    <span role="alert" tabindex="0">
      @if (!(vehicle$ | async); as vehicle) {
      <div class="text-center verify-vehicle-header" role="heading" aria-level="2"><strong>{{
          'ASP_LANDING.VERIFY_VEHICLE' | translate }}</strong></div>
      }
      <!-- <p class="text-center">Select your state and enter your mileage for pricing</p> -->
    </span>
    }
    @if (currentBrand != 'NCESI') {
    <span role="alert" tabindex="0">
      @if (!(vehicle$ | async)) {
      <div class="text-center verify-vehicle-header" role="heading" aria-level="2"><strong
          [innerHTML]="titleText | safeHtml"></strong></div>
      }
      <!-- <p class="text-center">Select your state and enter your mileage for pricing</p> -->
    </span>
    }
    <div class="row">
      <!-- Desktop View-->
      <div class="desktop col-xl-12">
        <div class="d-flex justify-content-center align-items-center">
          @if (vehicle$ | async; as vehicle) {
          <div class="vehicle_section mb-3">
            <div class="view image-cropper image-border mr-3 d-flex align-items-center"
              [ngClass]="{'hide-slug': vehicle.image}">
              @if (vehicle.image) {
              <img [src]="vehicle.image"
                alt="{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.trim }}" />
              }
            </div>
            <div class="vehicle_edit_btn d-flex justify-content-center align-items-center" (click)="editVehicle()">
              <mdb-icon fas icon="pencil-alt"></mdb-icon>
            </div>
          </div>
          }
          @if (vehicle$ | async; as vehicle) {
          <div class="d-flex flex-column justify-content-center">
            <div tabindex="0" class="bold uppercase">{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }} {{
              vehicle.trim }}</div>
            <div class="mb-3" role="region" tabindex="0">{{ 'ASP_LANDING.VIN' | translate }} {{ vehicleVin }}</div>
          </div>
          }
        </div>
      </div>
      <!-- Mobile View-->
      <div class="col-xl-12 pr-4 pl-4 mobile">
        <div class="d-flex justify-content-center">
          @if (vehicle$ | async; as vehicle) {
          <div class="d-flex flex-column justify-content-center">
            <div tabindex="0" class="bold uppercase text-center">{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model
              }} {{ vehicle.trim }}</div>
            <div class="mb-3 text-center" role="region" tabindex="0">{{ 'ASP_LANDING.VIN' | translate }} {{ vehicleVin
              }}</div>
          </div>
          }
        </div>
      </div>
      @if (vehicle$ | async; as vehicle) {
      <div class="col-12 p-0">
        <div class="mt-2 mb-4">
          @if ((modalComponentState$ | async) === 'error') {
          <div class="alert alert-warning verify-alert w-100" role="alert">
            @if (currentBrand != 'NCESI' && !((currentBrand === 'BMW' || currentBrand === 'MINI') &&
            modelFormValidation.get('registeredState')?.value === 'CA')) {
            <span>
              {{ 'ERRORS.NO_ELIGIBLE_PRODUCTS' | translate }} {{ branding.cs_phone_number }}
            </span>
            }
            @if ((currentBrand === 'BMW' || currentBrand === 'MINI') &&
            modelFormValidation.get('registeredState')?.value === 'CA') {
            <span>
              {{'ERRORS.NO_ELIGIBLE_PRODUCTS_CA' | translate: {brand: currentBrand} }}
            </span>
            }
            @if (currentBrand == 'NCESI') {
            <span>
              {{ 'ERRORS.NEED_MORE_INFO' | translate }} {{ branding.cs_phone_number }}
            </span>
            }
          </div>
          }
          @if ((modalComponentState$ | async) === 'invalidState') {
          <div class="alert alert-warning verify-alert w-100" id="invalidStateMobile" role="alert">
            {{ 'ERRORS.NO_PRODUCTS_STATE' | translate }} {{ branding.cs_phone_number }}
          </div>
          }
          @if ((modalComponentState$ | async) === 'productExist') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.CONTRACT_EXISTS' | translate }} {{
            branding.cs_phone_number }}
          </div>
          }
          @if ((modalComponentState$ | async) === 'lamboNeverEligible') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.NO_ELIGIBLE_PRODUCTS' | translate
            }}
            {{branding.cs_phone_number }}
          </div>
          }
          @if ((modalComponentState$ | async) === 'hasExistingClaims') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.ACTIVE_CLAIMS_ERROR' | translate
            }}
          </div>
          }
          @if ((modalComponentState$ | async) === 'mileageOrAgeExceeded') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.MILEAGE_OR_AGE_EXCEEDED' |
            translate }}
          </div>
          }
          @if ((modalComponentState$ | async) === 'ncesiMileageOrAgeExceeded') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.NCESI_MILEAGE_OR_AGE_EXCEEDED' |
            translate }}
          </div>
          }
        </div>
        <form class="text-center p-3" class="stateMileageForm OID-form" [formGroup]="modelFormValidation" role="form">
          <div class="md-form mt-3">
            <label class="no-touch-label" id="stateLabel" for="registeredState"
              [ngClass]="{ active: modelFormValidation.controls.registeredState.value != null }"> {{ 'ASP_LANDING.STATE'
              | translate }}</label>
            <!-- <mdb-select  role="listbox" aria-label="State of vehicle registration" (opened)="fixSelectAria($event)" tabindex="0" [options]="stateData" formControlName="registeredState" id="registeredState" (selected)="stateSelected()" mdbInput mdbValidate placeholder="Registered in... *" ></mdb-select> -->
            <select role="listbox" aria-labelledby="stateLabel" id="stateOfVehicleRegistrationSelect"
              class="form-control" formControlName="registeredState" (change)="stateSelected()"
              placeholder="Registered in... *">
              @for (state of stateData; track state) {
              <option value="{{ state.value }}">{{ state.label }}</option>
              }
            </select>
          </div>
          @if (modelFormValidation.controls.registeredState.invalid &&
          (modelFormValidation.controls.registeredState.dirty || modelFormValidation.controls.registeredState.touched))
          {
          <mdb-error role="alert">*{{
            'ASP_LANDING.STATE_REQUIRED' | translate }}</mdb-error>
          }
          <div class="md-form mt-3 odometer-container">
            @if ( currentBrand != 'REV') {
              <label id="odometerIdLabel" for="currentMileageInput">{{ 'ASP_LANDING.CURRENT_MILEAGE' | translate }}
                @if (odometerTooltip) {
                <app-tooltip message="{{odometerTooltip}}"></app-tooltip>
                }</label>
              }
              @if ( currentBrand == 'REV') {
                <label id="odometerIdLabel" for="currentMileageInput">
                  {{ 'ASP_LANDING.REV_CURRENT_ODOMETER_MILEAGE' | translate }}
                  @if (odometerTooltip) {
                  <app-tooltip message="{{odometerTooltip}}"></app-tooltip>
                  }</label>
                }
            <input data-public aria-labelledby="odometerIdLabel" mdbInput mdbValidate type="text"
              id="currentMileageInput" formControlName="odometer" class="form-control"
              (keypress)="onlyNumberKey($event)" (focus)="removeCommas()" (change)="removeCommas()" (blur)="addCommas()"
              max="100000" />
            <div class="invalid-feedback" for="odometerId">{{ 'ASP_LANDING.ENTER_MILEAGE' | translate }}</div>
          </div>
          @if (odometerModal && currentBrand != 'REV') {
          <div class="odometer-photo-container mb-3">
            <span>{{ 'ASP_LANDING.ODOMETER_PHOTO' | translate }}</span>
          </div>
          }
          @if (modelFormValidation.controls.odometer.invalid && (modelFormValidation.controls.odometer.dirty ||
          modelFormValidation.controls.odometer.touched)) {
          <mdb-error role="alert" class="mileage-error">*{{
            'ASP_LANDING.MILEAGE_REQUIRED' | translate }}</mdb-error>
          }
          <div class="row w-100">
            <div class="col-12 d-flex justify-content-center">
              <button mdbBtn id="getYourPriceButton"
                class="modal-component-see-pricing-btn btn primary-btn flat waves-light" mdbWavesEffect type="submit"
                [disabled]="inlineLoader$ | async" (click)="checkIfCriteriaChange()">
                @if (currentBrand == 'NCESI') {
                <span>
                  @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
                  <span class="">{{
                    'ASP_LANDING.VERIFY_VEHICLE_BUTTON' | translate }}</span>
                  }
                </span>
                }
                @if (currentBrand != 'NCESI') {
                <span>
                  @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
                  <span class="">{{buttonText}}</span>
                  }
                </span>
                }
                @if (inlineLoader$ | async) {
                <span>
                  <span class="spinner-border spinner-border-sm"></span>
                  {{ 'ASP_LANDING.LOADING' | translate }}
                </span>
                }
              </button>
            </div>
            <div class="col-12 change-vehicle text-center">
              {{ 'ASP_LANDING.NOT_VEHICLE' | translate }}
              <a role="link" href="javascript:void(0)" class="blue-link uppercase" (click)="editVehicle()"
                (click)="view = '2'"> {{ 'ASP_LANDING.CHANGE_VEHICLE' | translate }}</a>
            </div>
          </div>
        </form>
      </div>
      }
    </div>
  </div>
  }
  @if ((appFlowState$ | async) === 'guest' || (appFlowState$ | async) === 'edit') {
  <div class="vehicle-edit">
    <div class="col-12 text-center pb-3">
      @if (currentBrand == 'NCESI') {
      <span role="alert" tabindex="0">
        @if (!(vehicle$ | async); as vehicle) {
        <div class="text-center verify-vehicle-header" role="heading" aria-level="2"><strong>{{
            'ASP_LANDING.VERIFY_VEHICLE' | translate }}</strong></div>
        }
        <!-- <p class="text-center">Select your state and enter your mileage for pricing</p> -->
      </span>
      }
      @if (currentBrand != 'NCESI') {
      <span role="alert" tabindex="0">
        @if (!(vehicle$ | async) || currentBrand == 'REV') {
        <div class="text-center verify-vehicle-header" role="heading" aria-level="2"><strong
            [innerHTML]="titleText | safeHtml"></strong></div>
        @if (currentBrand == 'REV') {
        <div class="text-left">{{ 'ASP_LANDING.EXPLORE_PLANS_NO_SALES_CALLS' | translate }}</div>
        }
        }
        <!-- <p class="text-center">Select your state and enter your mileage for pricing</p> -->
      </span>
      }
      @if (currentBrand == 'Vroom') {
      <label class="text-center mt-3 no-touch-label">
        {{warrantyEligibility}}</label>
      }
    </div>
    <div>
      <form class="row" [formGroup]="editVehicleVINForm" class="no-OID-form">
        <div class="col-sm-12">
          @if ((modalComponentState$ | async) === 'error') {
          <div class="alert alert-warning verify-alert w-100" role="alert">
            @if (currentBrand != 'NCESI' && !((currentBrand === 'BMW' || currentBrand === 'MINI') &&
            editVehicleVINForm.get('editVehicleRegisteredStateVIN')?.value === 'CA')) {
            <span>
              {{ 'ERRORS.NO_ELIGIBLE_PRODUCTS' | translate }} {{ branding.cs_phone_number }}
            </span>
            }
            @if ((currentBrand === 'BMW' || currentBrand === 'MINI') &&
            editVehicleVINForm.get('editVehicleRegisteredStateVIN')?.value === 'CA') {
            <span>
              {{'ERRORS.NO_ELIGIBLE_PRODUCTS_CA' | translate: {brand: currentBrand} }}
            </span>
            }
            @if (currentBrand == 'NCESI') {
            <span>
              {{ 'ERRORS.NEED_MORE_INFO' | translate }} {{ branding.cs_phone_number }}.
            </span>
            }
          </div>
          }
          @if ((modalComponentState$ | async) === 'invalidState') {
          <div class="alert alert-warning verify-alert w-100" id="invalidStateDesktop" role="alert">
            {{ 'ERRORS.NO_PRODUCTS_STATE' | translate }} {{ branding.cs_phone_number }}
          </div>
          }
          @if ((modalComponentState$ | async) === 'productExist') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.CONTRACT_EXISTS' | translate }} {{
            branding.cs_phone_number }}</div>
          }
          @if ((modalComponentState$ | async) === 'lamboNeverEligible') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.NO_ELIGIBLE_PRODUCTS' | translate
            }}
            {{branding.cs_phone_number }}
          </div>
          }
          @if ((verifyVin$ | async) === 'failed') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{
            'ERRORS.NO_OFFER' | translate }}</div>
          }
          @if ((modalComponentState$ | async) === 'hasExistingClaims') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.ACTIVE_CLAIMS_ERROR' | translate
            }}</div>
          }
          @if ((modalComponentState$ | async) === 'mileageOrAgeExceeded') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.MILEAGE_OR_AGE_EXCEEDED' |
            translate }}</div>
          }
          @if ((modalComponentState$ | async) === 'ncesiMileageOrAgeExceeded') {
          <div class="alert alert-warning verify-alert w-100" role="alert">{{ 'ERRORS.NCESI_MILEAGE_OR_AGE_EXCEEDED' |
            translate }}</div>
          }
        </div>
        <div class="col-sm-12">

          <div class="md-form mt-4">
            @if(currentBrand == 'REV') {
            <label id="vinlabel" for="vinInput" class="text-left mt-2"><strong>{{
                'ASP_LANDING.REV_ENTER_YOUR_VIN' | translate }}</strong> {{ 'ASP_LANDING.REV_TO_SEE_CUSTOM_PRICING' |
              translate }}</label>
            }
            @if(currentBrand != 'REV') {
            <a id="whereFindVinLink" role="link" tabindex="0" class="where-vin blue-link uppercase"
              (click)="launchVin()">{{
              'ASP_LANDING.WHERE_FIND_VIN' | translate }}</a>

            <label id="vinlabel" for="vinInput">{{ 'ASP_LANDING.VIN' | translate }}</label>
            }
            <input data-public aria-labelledby="vinlabel" mdbInput mdbValidate type="text" id="vinInput"
              oninput="this.value = this.value.toUpperCase()" formControlName="editVehicleVIN" class="form-control"
              minlength="17" maxlength="17" />
          </div>
          @if (editVehicleVINForm.controls.editVehicleVIN.invalid && (editVehicleVINForm.controls.editVehicleVIN.dirty
          || editVehicleVINForm.controls.editVehicleVIN.touched)) {
          <mdb-error role="alert">
            @if (!editVehicleVINForm.controls.editVehicleVIN.errors?.pattern &&
            editVehicleVINForm.controls.editVehicleVIN.errors.required) {
            <span>*{{ 'ASP_LANDING.VIN_REQUIRED' | translate }}</span>
            }
            @if (!editVehicleVINForm.controls.editVehicleVIN.errors?.pattern &&
            editVehicleVINForm.controls.editVehicleVIN.errors.minlength) {
            <span>*{{ 'ASP_LANDING.VALID_VIN' | translate }}</span>
            }
            @if (editVehicleVINForm.controls.editVehicleVIN.errors?.pattern &&
            editVehicleVINForm.controls.editVehicleVIN.errors?.pattern.requiredPattern.indexOf('[a-zA-Z0-9]{0,17}') >
            -1) {
            <span>
              <span>*{{ 'ASP_LANDING.VALID_VIN' | translate }}</span>
            </span>
            }
            @if (editVehicleVINForm.controls.editVehicleVIN.errors?.pattern &&
            editVehicleVINForm.controls.editVehicleVIN.errors?.pattern.requiredPattern.indexOf('[a-zA-Z0-9]{0,12}[0-9]{5}$')
            > -1) {
            <span>
              <span><strong class="uppercase">*{{ 'ASP_LANDING.INVALID_VIN' | translate }} </strong></span>
              <span>{{ 'ASP_LANDING.INVALID_VIN_MSG_3' | translate }}</span>
            </span>
            }
            @if (editVehicleVINForm.controls.editVehicleVIN.errors?.pattern &&
            editVehicleVINForm.controls.editVehicleVIN.errors?.pattern.requiredPattern.indexOf('[^IOQioq ]{0,17}') > -1)
            {
            <span>
              <span><strong class="uppercase">*{{ 'ASP_LANDING.INVALID_VIN' | translate }} </strong></span>
              <span>{{ 'ASP_LANDING.INVALID_VIN_MSG' | translate }}</span>
            </span>
            }
          </mdb-error>
          }
        </div>
        <div class="col-sm-12 odometer-container">
          <div class="md-form mt-3">
            @if ( currentBrand != 'REV') {
            <label id="odometerlabel" for="editVehicleOdometerVIN">{{ 'ASP_LANDING.CURRENT_MILEAGE' | translate }}
              @if (odometerTooltip) {
              <app-tooltip message="{{odometerTooltip}}"></app-tooltip>
              }</label>
            }
            @if ( currentBrand == 'REV') {
            <label id="odometerlabel" for="editVehicleOdometerVIN">
              {{ 'ASP_LANDING.REV_CURRENT_ODOMETER_MILEAGE' | translate }}
              @if (odometerTooltip) {
              <app-tooltip message="{{odometerTooltip}}"></app-tooltip>
              }</label>
            }
            <input data-public aria-labelledby="odometerlabel" mdbInput mdbValidate type="text" id="currentMileageInput"
              formControlName="editVehicleOdometerVIN" class="form-control" (keypress)="onlyNumberKey($event)"
              (change)="removeCommasVIN()" (focus)="removeCommasVIN()" (blur)="addCommasVIN()" />
          </div>
          @if (odometerModal && currentBrand != 'REV') {
          <div class="odometer-photo-container mb-3">
            <span>{{ 'ASP_LANDING.ODOMETER_PHOTO' | translate }}</span>
          </div>
          }
          @if (editVehicleVINForm.controls.editVehicleOdometerVIN.invalid &&
          (editVehicleVINForm.controls.editVehicleOdometerVIN.dirty ||
          editVehicleVINForm.controls.editVehicleOdometerVIN.touched)) {
          <mdb-error role="alert" class="mileage-error">*{{
            'ASP_LANDING.MILEAGE_REQUIRED' | translate }}</mdb-error>
          }
        </div>
        <div class="col-sm-12 state-container">
          <div class="md-form mt-3">
            <label class="no-touch-label" id="statelabel2" for="state"
              [ngClass]="{ active: editVehicleVINForm.controls.editVehicleRegisteredStateVIN.value != null }"> {{
              'ASP_LANDING.STATE' | translate }}</label>
            <!-- <mdb-select aria-labelledby="statelabel2" [options]="stateData" id="state" formControlName="editVehicleRegisteredStateVIN" (opened)="fixSelectAria($event)" (selected)="stateSelectedVIN($event)"></mdb-select> -->
            <select role="listbox" aria-labelledby="statelabel2" id="stateOfVehicleRegistrationSelect"
              class="form-control" formControlName="editVehicleRegisteredStateVIN" (change)="stateSelectedVIN($event)">
              @for (state of stateData; track state) {
              <option value="{{ state.value }}">{{ state.label }}</option>
              }
            </select>
          </div>
          @if (editVehicleVINForm.controls.editVehicleRegisteredStateVIN.invalid &&
          (editVehicleVINForm.controls.editVehicleRegisteredStateVIN.dirty ||
          editVehicleVINForm.controls.editVehicleRegisteredStateVIN.touched)) {
          <mdb-error role="alert">*{{
            'ASP_LANDING.STATE_REQUIRED' | translate }}</mdb-error>
          }
        </div>
        <div class="row w-100 d-flex justify-content-center">
          <!-- <div class="col-md-6 col-12">
                    <a class="btn secondary-btn waves-light shadow-sm float-left" mdbBtn mdbWavesEffect (click)="refreshState()" (click)="modalRef.hide()"><mdb-icon far icon="edit"></mdb-icon> Close</a>
                  </div> -->
          <div class="col-12 text-center">
            <button mdbBtn id="getYourPriceButton" class="modal-component-see-pricing-btn btn primary-btn waves-light"
              mdbWavesEffect type="submit" (click)="checkIfCriteriaChangeEditedVIN()"
              [disabled]="(inlineLoader$ | async) || (verifyVin$ | async) === 'failed'">
              @if (currentBrand == 'NCESI') {
              <span>
                @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
                <span class="">{{
                  'ASP_LANDING.VERIFY_VEHICLE_BUTTON' | translate }}</span>
                }
              </span>
              }
              @if (currentBrand != 'NCESI') {
              <span>
                @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
                <span class="">{{buttonText}}</span>
                }
              </span>
              }
              @if (inlineLoader$ | async) {
              <span>
                <span class="spinner-border spinner-border-sm"></span>
                {{ 'ASP_LANDING.LOADING' | translate }}
              </span>
              }
            </button>
          </div>
          @if ((vehicle$ | async) && odometerModal) {
          <div class="col-12 change-vehicle text-center">
            <a role="link" href="javascript:void(0)" class="blue-link uppercase" (click)="backToAccount()">
              <mdb-icon fas icon="arrow-left"></mdb-icon> {{ 'ASP_LANDING.GO_BACK' | translate }}
            </a>
          </div>
          }
        </div>
      </form>
    </div>
  </div>
  }
</div>
}